import { useCallback, useEffect, useState } from 'react';
import { opsNotifications, markOpsNotificationsRead, opsErr, okCode } from '../../api/ops';
import { useToast } from '../../components/Toast';
import { OpsGate, fmtDateTime } from './opsCommon';

// THÔNG BÁO VẬN HÀNH (app "i love GTS"): thông báo SocSon gửi cho NV. Bấm = đánh dấu đã đọc, có link thì mở.
function Notify() {
  const toast = useToast();
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [unreadOnly, setUnreadOnly] = useState(false);

  const load = useCallback(async () => {
    setLoading(true);
    try {
      const d = await opsNotifications();
      setItems(okCode(d) ? d.data?.results || [] : []);
    } catch (e) {
      toast(opsErr(e, 'Không tải được thông báo'), 'danger');
    } finally {
      setLoading(false);
    }
  }, [toast]);
  useEffect(() => { load(); }, [load]);

  const open = async (n) => {
    let link = '';
    try { link = (typeof n.data === 'string' ? JSON.parse(n.data) : n.data || {}).link || ''; } catch { /* data không phải JSON */ }
    if (!n.is_read) {
      setItems((prev) => prev.map((x) => (x === n ? { ...x, is_read: true } : x)));
      markOpsNotificationsRead([n.id || n._id]).catch(() => {});
    }
    if (link) window.open(link, '_blank', 'noopener');
  };

  const shown = unreadOnly ? items.filter((n) => !n.is_read) : items;
  const unread = items.filter((n) => !n.is_read).length;

  return (
    <>
      <div className="row" style={{ marginBottom: 10 }}>
        <button className={`chip${!unreadOnly ? ' done' : ' todo'}`} onClick={() => setUnreadOnly(false)}>Tất cả</button>
        <button className={`chip${unreadOnly ? ' done' : ' todo'}`} onClick={() => setUnreadOnly(true)}>Chưa đọc ({unread})</button>
        <button className="btn sm ghost" style={{ marginLeft: 'auto' }} onClick={load} title="Tải lại"><i className="ti ti-refresh" /></button>
      </div>
      {loading ? <div className="empty">Đang tải…</div> : !shown.length ? <div className="empty">Không có thông báo.</div> : (
        <div className="ops-list">
          {shown.map((n, i) => (
            <button key={n.id || n._id || i} type="button" className={`ops-hist${n.is_read ? ' ops-read' : ''}`} onClick={() => open(n)}>
              <div className="row between"><b>{n.title}</b>{!n.is_read && <span className="ops-dot" />}</div>
              <div className="small">{n.content || n.summary}</div>
              <div className="small muted">{fmtDateTime(n.createdAt || n.created_date)}</div>
            </button>
          ))}
        </div>
      )}
    </>
  );
}

export default function OpsNotifyPage({ onBack }) {
  return (
    <OpsGate onBack={onBack} title="Thông báo vận hành" sub="Thông báo từ SocSon gửi cho tài khoản của bạn">
      <Notify />
    </OpsGate>
  );
}
